import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import Tooltip from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import Slider from "react-slick";
import Badge from "@mui/material/Badge";

import DraggableDialog from "components/UpStyled/DraggableDialog";
import ChatRoom from "pages/messages/chatroom";
import ContactAvatar from "components/UpStyled/ContactAvatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AvatarGroup from "@mui/material/AvatarGroup";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CopyrightIcon from "@mui/icons-material/Copyright";
import AddIcon from "@mui/icons-material/Add";

import api from "services/api";
import { AccountContext } from "context/account";

import { toast } from "react-hot-toast";
import { socket } from "services/request";

import { privilegeOptions } from "utils/data";

import QuickShareChangeModal from "./QuickShareChangeModal";
import Prompt from "components/UpStyled/Prompt";
import CrownIcon from "components/Icon/CrownIcon";

const SIZEMAP = {
  sm: 26,
  md: 32,
  lg: 36,
};

const AvatarComplex = ({
  user,
  store,
  size = "sm",
  onAvatarClick = null,
  sx = {},
  sharedSessions = null,
  tooltip,
  icon,
  iconColor = "info",
  isOwner,
}) => {
  const account = useContext(AccountContext);

  const avatarSize = SIZEMAP[size] || 36;
  let myStore = store
    ? store
    : user?.user?.stores && user?.user?.stores.length > 0
    ? user?.user?.stores[0]
    : {};

  var inSession = sharedSessions !== null && sharedSessions.find((s) => s.senderId === myStore?.id);
  return (
    <SuiBox display="flex">
      <Tooltip title={tooltip ? tooltip : ""}>
        <SuiBox
          sx={{
            ...sx,
          }}
          onClick={onAvatarClick ? (e) => onAvatarClick(e, user) : null}
        >
          {icon || isOwner ? (
            <SuiBox
              borderRadius="50%"
              width={avatarSize + 8}
              height={avatarSize + 8}
              display="flex"
              justifyContent="center"
              alignItems="center"
              color="white"
              border={({ borders: { borderWidth }, palette: { info } }) =>
                inSession ? `${borderWidth[1]} solid ${info.main}` : "none"
              }
              sx={{ cursor: "pointer", pl: 1 }}
            >
              <Badge
                color={iconColor}
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={isOwner ? <CrownIcon size={4} color="warning" /> : icon}
                componentsProps={{
                  badge: {
                    sx: { padding: "0", height: "auto", minWidth: 0 },
                  },
                }}
              >
                <Avatar
                  src={myStore?.metadata?.avatar}
                  sx={{
                    width: avatarSize,
                    height: avatarSize,
                  }}
                />
              </Badge>
            </SuiBox>
          ) : (
            <SuiBox
              py={0.5}
              borderRadius="50%"
              width={avatarSize + 8}
              height={avatarSize + 8}
              display="flex"
              justifyContent="center"
              alignItems="center"
              color="white"
              border={({ borders: { borderWidth }, palette: { info } }) =>
                inSession ? `${borderWidth[1]} solid ${info.main}` : "none"
              }
              sx={{ cursor: "pointer" }}
            >
              <Avatar
                src={myStore?.metadata?.avatar}
                sx={{
                  width: avatarSize,
                  height: avatarSize,
                }}
              />
            </SuiBox>
          )}{" "}
        </SuiBox>
      </Tooltip>
    </SuiBox>
  );
};

export default AvatarComplex;
